export default __webpack_public_path__ + "static/media/AcornOffice_34.cd5111d6.png";